import type { JSX } from 'react';
import type { HelpSlug } from '@inventohub/shared';

export function HelpChooserIcon({ slug }: { slug: HelpSlug }): JSX.Element {
  return (
    <svg
      className="service-icon"
      viewBox="0 0 24 24"
      width="28"
      height="28"
      aria-hidden="true"
      data-icon={slug}
    >
      {iconPath(slug)}
    </svg>
  );
}

function iconPath(slug: HelpSlug): JSX.Element {
  switch (slug) {
    case 'sign-in':
      return (
        <path
          fill="currentColor"
          d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-4 0-8 2-8 5v1h16v-1c0-3-4-5-8-5z"
        />
      );
    case 'scan':
      return (
        <path
          fill="currentColor"
          d="M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm10-2h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm4 8h2v2h-2v-2z"
        />
      );
    case 'inventory':
    case 'inventory-results':
      return <path fill="currentColor" d="M4 4h16v4H4V4zm0 6h16v10H4V10zm3 2v2h10v-2H7z" />;
    case 'events':
    case 'event-edit':
      return (
        <path
          fill="currentColor"
          d="M7 2h2v2h6V2h2v2h3v18H4V4h3V2zm12 8H5v10h14V10zM6 6v2h12V6H6z"
        />
      );
    case 'availability':
      return (
        <path
          fill="currentColor"
          d="M7 2h2v2h6V2h2v2h3v18H4V4h3V2zm12 8H5v10h14V10zM8 13h2v2H8v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zM8 17h8v2H8v-2z"
        />
      );
    case 'shipped-via':
      return (
        <path
          fill="currentColor"
          d="M2 8h14v8H2V8zm14 3h4l2 3v2h-6v-5zM5 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        />
      );
    case 'event-codes':
      return (
        <path fill="currentColor" d="M7 7h10v2H7V7zm0 4h10v2H7v-2zm0 4h6v2H7v-2zM4 5h16v14H4V5z" />
      );
    case 'moves':
      return <path fill="currentColor" d="M3 7h18v13H3V7zm2 2v9h14V9H5zm3-5h8l2 3H6l2-3z" />;
    case 'labels':
      return <path fill="currentColor" d="M3 7h11l7 5-7 5H3V7zm3 3a2 2 0 1 0 2 2 2 2 0 0 0-2-2z" />;
    case 'users':
      return (
        <path
          fill="currentColor"
          d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-4 0-8 2-8 5v1h16v-1c0-3-4-5-8-5z"
        />
      );
    case 'replacements':
      return (
        <path
          fill="currentColor"
          d="M12 2 4 6v6c0 5 3.4 9.4 8 10 4.6-.6 8-5 8-10V6l-8-4zm0 4 4.5 2.2-.8 1.8L12 8.2 8.3 10l-.8-1.8L12 6z"
        />
      );
    case 'glossary':
      return (
        <path
          fill="currentColor"
          d="M5 4h9a3 3 0 0 1 3 3v13H8a3 3 0 0 0-3 3V4zm2 3v12.5A4.5 4.5 0 0 1 8 19h7V7H7z"
        />
      );
  }
}
